import React from 'react';
import type { ReactNode } from 'react';

import { StyledLink } from './styles';
import { HEADER_BANNER_LINK_DATA_TEST_ID } from '../constants';

interface IOptionalClickable {
  children: ReactNode;
  href?: string;
}

export const OptionalClickable = (props: IOptionalClickable): JSX.Element => {
  const { children, href } = props;

  if (!href) return <>{children}</>;

  return (
    <StyledLink
      href={href}
      target="_blank"
      data-testid={HEADER_BANNER_LINK_DATA_TEST_ID}
    >
      {children}
    </StyledLink>
  );
};
